import { useState } from "react";
import { SmilePlus } from "lucide-react";
import EmojiPicker, { Theme } from "emoji-picker-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const QUICK_EMOJIS = ["👍", "✅", "🔥", "👀", "🎉", "❤️", "😂"];

export default function MessageReactions({ message, userId, onReact }) {
  const [pickerOpen, setPickerOpen] = useState(false);
  const reactions = message.reactions || {};
  const entries = Object.entries(reactions).filter(([, list]) => list?.length);

  return (
    <div className="flex items-center gap-1.5 flex-wrap mt-1.5">
      {entries.map(([emoji, list]) => {
        const mine = list.some((r) => r.user_id === userId);
        return (
          <button
            key={emoji}
            data-testid={`reaction-pill-${message.id}-${emoji}`}
            onClick={() => onReact(message.id, emoji)}
            title={list.map((r) => r.name).join(", ")}
            className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border transition-colors ${
              mine
                ? "bg-red-950/60 border-red-800/70 text-red-200"
                : "bg-[#1E2029] border-[#2E3242] text-gray-400 hover:border-red-900/50"
            }`}
          >
            <span className="text-sm leading-none">{emoji}</span>
            <span className="font-mono">{list.length}</span>
          </button>
        );
      })}

      <div className="flex items-center gap-0.5 opacity-100 md:opacity-0 md:group-hover:opacity-100 md:focus-within:opacity-100 transition-opacity">
        {QUICK_EMOJIS.map((e) => (
          <button
            key={e}
            data-testid={`quick-react-${message.id}-${e}`}
            onClick={() => onReact(message.id, e)}
            className="w-6 h-6 rounded-md text-sm leading-none flex items-center justify-center hover:bg-[#262936] hover:scale-110 transition-transform"
          >
            {e}
          </button>
        ))}
        <Popover open={pickerOpen} onOpenChange={setPickerOpen}>
          <PopoverTrigger asChild>
            <button
              data-testid={`emoji-picker-trigger-${message.id}`}
              className="w-6 h-6 rounded-md flex items-center justify-center text-gray-500 hover:text-red-300 hover:bg-[#262936]"
              title="More emojis"
            >
              <SmilePlus className="w-3.5 h-3.5" />
            </button>
          </PopoverTrigger>
          <PopoverContent
            align="start"
            className="w-auto p-0 border-red-900/30 bg-transparent shadow-2xl"
            data-testid={`emoji-picker-${message.id}`}
          >
            <EmojiPicker
              theme={Theme.DARK}
              width={300}
              height={380}
              lazyLoadEmojis
              skinTonesDisabled
              previewConfig={{ showPreview: false }}
              onEmojiClick={(d) => {
                onReact(message.id, d.emoji);
                setPickerOpen(false);
              }}
            />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}
